import React from "react";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { infoClassData } from "./infoenum";

const CopperInt = props => (
  <div>
    <Table className={props.classes.table}>
      <TableBody>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("test_types_signaltek")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.translate(props.data.type)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("sub_test_link_status")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.linkstatus}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("sub_test_link_speed")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.linkspeed}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("result_duplex")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.linkduplex}
          </TableCell>
        </TableRow>
        {props.blackbirdInterface && <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("link_ability")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.linkability}
          </TableCell>
        </TableRow>}
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("subtest_poeload_poestatus")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.poestatus}
            {props.data.eth.poeclass &&
                infoClassData.find(o => o.name === props.data.eth.poeclass) ? " (" + props.translate(infoClassData.find(o => o.name === props.data.eth.poeclass).id) + ")" : ""}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("result_poe_pow")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.poepower.toFixed(2)}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first} />
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table className={`${props.classes.itabTable} ${props.classes.itabCols2}`}>
              <tr>
                <th className={props.classes.itabVoltageHeader} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.translate("result_p1236")}
                </th>
                <th className={props.classes.itabVoltageHeader} style={{ border: "none" }}>
                  {props.translate("result_p4578")}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("result_poe_vol")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table className={`${props.classes.itabTable} ${props.classes.itabCols2}`}>
              <tr>
                <th className={props.classes.itabVoltageData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.pair1236voltage && props.data.eth.pair1236voltage.toFixed(2)}
                </th>
                <th className={props.classes.itabVoltageData} style={{ border: "none" }}>
                  {props.data.eth.pair4578voltage && props.data.eth.pair4578voltage.toFixed(2)}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>
        {props.isNavitek && <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {"LLDP " + props.translate("subtest_poeload_poestatus")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            {props.data.eth.lldppoestatus && props.data.eth.lldppoestatus.indexOf("No PoE") != -1 ? props.translate("lldpNoPoe") : props.data.eth.lldppoestatus}
            {props.data.eth.lldppoeclass &&
                infoClassData.find(o => o.name === props.data.eth.lldppoeclass) ? " (" + props.translate(infoClassData.find(o => o.name === props.data.eth.lldppoeclass).id) + ")" : ""}
          </TableCell>
        </TableRow>}
        {props.isNavitek &&  <TableRow>
          <TableCell className={props.classes.tablecontent_first} />
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table className={`${props.classes.itabTable} ${props.classes.itabCols3}`}>
              <tr>
                <th className={props.classes.itabLldpPoeHeader} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.translate("requested")}
                </th>
                <th className={props.classes.itabLldpPoeHeader} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.translate("allocated")}
                </th>
                <th className={props.classes.itabLldpPoeHeader} style={{ border: "none" }}>
                  {props.translate("measured")}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>}
        {props.isNavitek && <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {"LLDP " + props.translate("result_poe_pow")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table className={`${props.classes.itabTable} ${props.classes.itabCols3}`}>
              <tr>
                <th className={props.classes.itabLldpPoeData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.lldprequestedpower && props.data.eth.lldprequestedpower.toFixed(2)}
                </th>
                <th className={props.classes.itabLldpPoeData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.lldpallocatedpower && props.data.eth.lldpallocatedpower.toFixed(2)}
                </th>
                <th className={props.classes.itabLldpPoeData} style={{ border: "none" }}>
                  {props.data.eth.lldppoepower && props.data.eth.lldppoepower.toFixed(2)}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>}
        {props.isNavitek && <TableRow>
          <TableCell className={props.classes.tablecontent_first} />
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table className={`${props.classes.itabTable} ${props.classes.itabCols2}`}>
              <tr>
                <th className={props.classes.itabVoltageHeader} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.translate("result_p1236")}
                </th>
                <th className={props.classes.itabVoltageHeader} style={{ border: "none" }}>
                  {props.translate("result_p4578")}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>}
        {props.isNavitek && <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {"LLDP " + props.translate("result_poe_vol")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table className={`${props.classes.itabTable} ${props.classes.itabCols2}`}>
              <tr>
                <th className={props.classes.itabVoltageData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.lldppair1236voltage && props.data.eth.lldppair1236voltage.toFixed(2)}
                </th>
                <th className={props.classes.itabVoltageData} style={{ border: "none" }}>
                  {props.data.eth.lldppair4578voltage && props.data.eth.lldppair4578voltage.toFixed(2)}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>}
        <TableRow>
          <TableCell className={props.classes.tablecontent_first} />
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table className={`${props.classes.itabTable} ${props.classes.itabCols4}`}>
              <tr>
                <th className={props.classes.itabPairHeader} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.translate("result_pr1")}
                </th>
                <th className={props.classes.itabPairHeader} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.translate("result_pr2")}
                </th>
                <th className={props.classes.itabPairHeader} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.translate("result_pr3")}
                </th>
                <th className={props.classes.itabPairHeader} style={{ border: "none" }}>
                  {props.translate("result_pr4")}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("result_skew")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table className={`${props.classes.itabTable} ${props.classes.itabCols4}`}>
              <tr>
                <th className={props.classes.itabPairData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.pair12skew && props.data.eth.pair12skew}
                </th>
                <th className={props.classes.itabPairData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.pair36skew && props.data.eth.pair36skew}
                </th>
                <th className={props.classes.itabPairData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.pair45skew && props.data.eth.pair45skew}
                </th>
                <th className={props.classes.itabPairData} style={{ border: "none" }}>
                  {props.data.eth.pair78skew && props.data.eth.pair78skew}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>
        {!props.blackbirdInterface && (<TableRow>
          <TableCell className={props.classes.tablecontent_first}>
            {props.translate("result_snr")}
          </TableCell>
          <TableCell className={props.classes.copper_tablecontent_first}>
            <table className={`${props.classes.itabTable} ${props.classes.itabCols4}`}>
              <tr>
                <th className={props.classes.itabPairData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.pair12snr && props.data.eth.pair12snr.toFixed(1)}
                </th>
                <th className={props.classes.itabPairData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.pair36snr && props.data.eth.pair12snr.toFixed(1)}
                </th>
                <th className={props.classes.itabPairData} style={{ border: "none", borderRight: "1px solid #ccc" }}>
                  {props.data.eth.pair45snr && props.data.eth.pair12snr.toFixed(1)}
                </th>
                <th className={props.classes.itabPairData} style={{ border: "none" }}>
                  {props.data.eth.pair78snr && props.data.eth.pair12snr.toFixed(1)}
                </th>
              </tr>
            </table>
          </TableCell>
        </TableRow>
        )}
      </TableBody>
    </Table>

  </div>
);
export default withStyles(styles)(CopperInt);
